<div [attr.data-qa]="qaTag" class="modal-dialog">
    <h2 [attr.data-qa]="qaTag + '-title'" class="modal-dialog-title">{{ 'VAULT_ADMIN.CARDS.ASSIGNING_CONTACTS.TITLE' | translate }}</h2>
    <ul class="list">
        @for (vaultMemberStatus of vaultMemberQueue(); track vaultMemberStatus.vaultMember.userId) {
            @if (vaultMemberStatus.status) {
                <li #item class="list-item">
                    <app-icon [attr.data-qa]="'user-icon-' + vaultMemberStatus.vaultMember.userFullName"
                              [iconSize]="AppIconSize.MEDIUM"
                              [iconUrl]="{url: vaultMemberStatus.vaultMember.iconId | apiIconUrl | authImage: { loadingElement: item }, fallback: ICONS.USER}"
                              aria-hidden="true"
                              class="list-item-icon"/>
                    <div class="list-item-title-group">
                        <app-document-filename [appTestTag]="'user-full-name-' + vaultMemberStatus.vaultMember.userFullName"
                                               [filename]="vaultMemberStatus.vaultMember.userFullName"
                                               class="list-item-text list-item-title"/>
                        @if (vaultMemberStatus.status === VaultMemberAssignStatusEnum.Error) {
                            <div [attr.data-qa]="'add-to-group-status-' + vaultMemberStatus.vaultMember.userFullName"
                                 class="list-item-text list-item-subtitle">{{ 'ERROR.CODES.CODE_' + (vaultMemberStatus.error?.code ?? '0') | translate }}
                            </div>
                        }
                    </div>
                    <div [attr.data-qa]="'add-to-group-status-icon-' + vaultMemberStatus.vaultMember.userFullName" class="list-item-badges">
                        @switch (vaultMemberStatus.status) {
                            @case (VaultMemberAssignStatusEnum.Waiting) {
                                <app-icon [attr.data-qa]="'add-to-group-status-icon-' + vaultMemberStatus.status | kebabCase"
                                          [iconSize]="AppIconSize.SMALL"
                                          [svgIcon]="ICONS.HOURGLAS"
                                          class="status-dialog-waiting-icon"/>
                            }
                            @case (VaultMemberAssignStatusEnum.InProgress) {
                                <div [attr.data-qa]="'add-to-group-status-icon-' + vaultMemberStatus.status | kebabCase" class="status-dialog-loader"></div>
                            }
                            @case (VaultMemberAssignStatusEnum.Error) {
                                <app-icon [appTooltipPosition]="TooltipPositionEnum.BOTTOM"
                                          [appTooltipText]="'ERROR.CODES.CODE_' + (vaultMemberStatus.error?.code ?? '0') | translate"
                                          [attr.data-qa]="'add-to-group-status-icon-' + vaultMemberStatus.status | kebabCase"
                                          [iconSize]="AppIconSize.SMALL"
                                          [svgIcon]="ICONS.THUMBS_DOWN"
                                          appTooltip/>
                            }
                            @case (VaultMemberAssignStatusEnum.Done) {
                                <app-icon [attr.data-qa]="'add-to-group-status-icon-' + vaultMemberStatus.status | kebabCase"
                                          [iconSize]="AppIconSize.SMALL"
                                          [svgIcon]="ICONS.THUMBS_UP"/>
                            }
                        }
                    </div>
                </li>
            }
        }
    </ul>
    <div class="modal-dialog-action-text-buttons">
        @if (vaultMembersAreInProgress() && !aborted()) {
            <app-button (clicked)="abort()"
                        [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                        [buttonText]="'BUTTON.CANCEL' | translate"
                        qaTag="close-status-dialog-button"/>
        } @else {
            <app-button (clicked)="close()"
                        [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                        [buttonColor]="ButtonColorEnum.RED"
                        [buttonText]="'BUTTON.OK' | translate"
                        qaTag="ok-status-dialog-button"/>
        }
    </div>
</div>
